// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputNumberRange_wrapper__Acb3d","icon":"InputNumberRange_icon__UTwk3","input":"InputNumberRange_input__Vtns_"};